import { render } from "./MessageList.vue?vue&type=template&id=1b1823c0&scoped=true&ts=true"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"

import "./MessageList.vue?vue&type=style&index=0&id=1b1823c0&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1823c0"]])

export default __exports__